import { useQuery } from '@tanstack/react-query';
import { voicesApi } from '../services/voicesApi';

export const useVoicesDropdown = () => {
  return useQuery({
    queryKey: ['voices-dropdown'],
    queryFn: () => voicesApi.getDropdown(),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
